import { Controller } from "@hotwired/stimulus"

// Photo gallery with prev/next/thumb navigation.
// Targets:
//   slide   — each <div> wrapping one photo, toggled via opacity
//   thumb   — thumbnail buttons at the bottom
//   current — the "1/N" counter span
// Actions: click->gallery#prev, #next, #goTo (with data-index)
export default class extends Controller {
  static targets = ["slide", "thumb", "current"]

  declare slideTargets: HTMLElement[]
  declare thumbTargets: HTMLElement[]
  declare currentTarget: HTMLElement
  declare hasCurrentTarget: boolean

  index = 0

  connect() {
    this.show(0)
  }

  next(event?: Event) {
    event?.preventDefault()
    this.show((this.index + 1) % this.slideTargets.length)
  }

  prev(event?: Event) {
    event?.preventDefault()
    const len = this.slideTargets.length
    this.show((this.index - 1 + len) % len)
  }

  goTo(event: Event) {
    event.preventDefault()
    const target = event.currentTarget as HTMLElement
    const idx = parseInt(target.dataset.index || "0", 10)
    this.show(idx)
  }

  private show(idx: number) {
    this.index = idx
    this.slideTargets.forEach((slide, i) => {
      if (i === idx) {
        slide.classList.add("opacity-100")
        slide.classList.remove("opacity-0")
      } else {
        slide.classList.add("opacity-0")
        slide.classList.remove("opacity-100")
      }
    })
    this.thumbTargets.forEach((thumb, i) => {
      if (i === idx) {
        thumb.classList.add("border-white")
        thumb.classList.remove("border-transparent", "opacity-70")
      } else {
        thumb.classList.add("border-transparent", "opacity-70")
        thumb.classList.remove("border-white")
      }
    })
    if (this.hasCurrentTarget) {
      this.currentTarget.textContent = String(idx + 1)
    }
  }
}
